import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux'
import FormError from '../partials/FormError';
import { getLocations, deleteLocation } from '../../actions/locations';
import { destructServerErrors, allErrors } from '../../helpers/error';
import __ from '../../helpers/translation';

const propTypes = {
  location: PropTypes.object,
  onDeleted: PropTypes.func,
};

function LocationDeleteModal(props) {
   
    const dispatch = useDispatch()

    const [isDeleting, setIsDeleting] = useState(false);
    const [errors, setErrors] = useState('');

    const deleteItem = () => {
        setErrors('');
        setIsDeleting(true);

        dispatch(deleteLocation(props.location))
            .then(data => {
                setIsDeleting(false);
                window.$('#deleteLocation').modal('hide');
                props.onDeleted();
            })
            .catch(error => {
                let errors = destructServerErrors(error);
                setErrors(errors ? allErrors(errors).join('') : __('app.inspections.delete_location_error'))
                setIsDeleting(false);
            });
    }

    if(!props.location){
        return '';
    }

    return (

        <div className="modal fade" id="deleteLocation" tabIndex="-1" role="dialog" aria-labelledby="deleteLocation" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600" id="exampleModalLongTitle">{ __('app.inspections.delete_location_title', {location: props.location.name}) }</h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {errors && 
                            (
                                <FormError>{errors}</FormError>
                            )
                        }
                        <button onClick={(e) => deleteItem()}
                            disabled={isDeleting}
                            className="btn btn-black d-block w-100 mt-5">
                            { __('app.general.delete') }
                            {isDeleting && (
                                <i className="far fa-circle-notch fa-spin ml-3"></i>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}

LocationDeleteModal.propTypes = propTypes;

export default LocationDeleteModal;